const $ = window.jQuery

import appUtils from './app_utils'

const preventClickOnSwiping = function() {
  $(this).on('pointerdown mousedown touchdown', function(event) {
    $(this).data('mouseStart', {x: event.pageX, y: event.pageY, moving: false }) 
    $(this).removeClass('is-swiping')
  })
  $(this).on('pointermove mousemove touchmove', function(event) {
    const mouseStart = $(this).data('mouseStart')
    if (mouseStart && !mouseStart.moving && Math.abs(event.pageX - mouseStart.x) > 30) {
      $(this).addClass('is-swiping')
      mouseStart.moving = true
    }
  })
  $(this).on('pointerup mouseup touchup', function(event) {
    const $that = $(this)
    setTimeout(()=>{
      const mouseStart = $that.data('mouseStart')
      if (mouseStart) {
        if (mouseStart.moving) {
          $that.removeClass('is-swiping')
        }
        $that.data('mouseStart', null )
      }
    }, 500)
  })
}

// Slick carousel: breakpoinst override
// https://github.com/kenwheeler/slick
const responsiveOverride = function(event, slick){
  let slidesToShow = [2,2,3,4]
  let responsiveOption = [
    {
      breakpoint: 1289,
      settings: {
        slidesToShow: slidesToShow[2],
        slidesToScroll: slidesToShow[2]
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: slidesToShow[1],
        slidesToScroll: slidesToShow[1]
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: slidesToShow[0],
        slidesToScroll: slidesToShow[0]
      }
    }
  ];
  slick.slickSetOption('slidesToShow', slidesToShow[3]);
  slick.slickSetOption('slidesToScroll', slidesToShow[3]);
  slick.slickSetOption('responsive', responsiveOption, true);
  slick.refresh()
  $(this).addClass('c24-slick-initialized');
}

/*
  * is-c24-kburns-effect
  */
const directionArr = ['normal', 'reverse']
// const transformOriginArr = ['10% 10%', '90% 10%', '90% 50%', '90% 90%', '10% 90%', '10% 50%']
const transformOriginArr = ['50% 10%', '90% 50%', '50% 90%', '10% 50%']
const directionKey = 'c24-direction'
const transformOriginKey = 'c24-transform-origin'
const slideRatio = 0.42
const slideRatioVertical = slideRatio * 2
const kburnsSetSlideAttr = function(event, slick, currentSlide, nextSlide) {
  const $slider = $(slick.$slider)
  const $nextSlide = $(slick.$slides[nextSlide])

  let directionIndex = ($slider.data(directionKey) !== undefined) ? $slider.data(directionKey) : 0;
  let transformOriginIndex = ($slider.data(transformOriginKey) !== undefined) ? $slider.data(transformOriginKey) : 0;

  const $img = $nextSlide.find('img')
  const imgHeight = $img.attr('height')
  const imgWidth = $img.attr('width')
  const imgRatio = imgHeight / imgWidth
  const useAnimationShift = (imgRatio > slideRatioVertical)
  if (useAnimationShift) {
    $img.css({
      'object-position': 'center top',
      '--img-ratio': imgRatio,
      '--transform-orign': 'center center',
      '--animation-name': 'shift'
    })
    $img.addClass('animation-shift')
  } else {
    $img.css({
      '--transform-orign': transformOriginArr[transformOriginIndex],
      '--animation-name': 'zoom'
    })
  }
  $img.css('--animation-direction', directionArr[directionIndex])
  // https://css-tricks.com/restart-css-animation/
  .removeClass('run-animation')
  // -> triggering reflow
  appUtils.reflow()
  // -> and re-adding the class
  // $img[0].classList.add("run-animation")
  $img.addClass('run-animation')

  // if (transformOriginIndex === 0) { // change zoom direction on forst transformOrigin
  if (nextSlide === (slick.$slides.length - 1)) { // change zoom direction on last slide
    directionIndex = (directionIndex < directionArr.length) ? directionIndex + 1 : 0
  }
  $slider.data(directionKey, directionIndex)
  if (!useAnimationShift) {
    transformOriginIndex = (transformOriginIndex < transformOriginArr.length) ? transformOriginIndex + 1 : 0
    $slider.data(transformOriginKey, transformOriginIndex)
  }
}

const kburnsInit = function(event, slick){
  const $slider = $(slick.$slider)
  $slider.css('--animation-duration', (slick.options.autoplaySpeed + slick.options.speed ) / 1000 + 's')
  // kburnsSetSlideAttr(event, slick, 0, 0)
}


let autoplayTimeout = null
const slickAutoplaySelecor = '[data-autoplay="true"] > .slick-initialized, [data-autoplay="true"].slick-initialized'
const autoplayonWindowResize = function() {
  $(slickAutoplaySelecor).each( (index, item) => {
    // console.log($(item.slick))
    // console.log($(item).slick('slickGetOption', 'autoplay'))
    $(item).slick('slickSetOption', 'autoplay', false)
    $(item).slick('slickPause')
  })
  if (autoplayTimeout) {
    clearTimeout(autoplayTimeout)
  }
  autoplayTimeout = setTimeout(()=>{
    // console.log('after resize')
    $(slickAutoplaySelecor).each( (index, item) => {
      // console.log($(item).slick('slickGetOption', 'autoplay'))
      $(item).slick('slickSetOption', 'autoplay', true)
      $(item).slick('slickPlay')
    })
  }, 2000)
}

const appInit = function() {
  // slick init event handler must be set before slick initialization, that occurs before pageview init for carousel in server side markup  
  $('.wp-block-getwid-post-carousel__wrapper').on('init', responsiveOverride);

  window.addEventListener('resize', autoplayonWindowResize )
}

const init = function() {
  $('.wp-block-getwid-post-carousel__wrapper').on('init', responsiveOverride);

  $('.wp-block-getwid-post-carousel__wrapper, .wp-block-getwid-images-slider__wrapper').each(preventClickOnSwiping);

  $('.is-c24-kburns-effect > div').on('init', kburnsInit)
  $('.is-c24-kburns-effect > div').on('beforeChange', kburnsSetSlideAttr)
}

const destroy = function() {
  $('.wp-block-getwid-post-carousel__wrapper').off('init', responsiveOverride);
  $('.wp-block-getwid-post-carousel__wrapper, .wp-block-getwid-images-slider__wrapper').off('pointerdown mousedown touchdown pointermove mousemove touchmove pointerup mouseup touchup')

  $('.is-c24-kburns-effect > div').off('init', kburnsInit)
  $('.is-c24-kburns-effect > div').off('beforeChange', kburnsSetSlideAttr)
}

export default {init, destroy, appInit}